import React from 'react';
import { HeaderContainer, TitleContainer } from './headerStyles';
import { Gradient } from '../../Global/styles';
import { checkImage } from '../../componentUtils';
import { ITaxonomy } from '../../../models/interfaces/ITaxonomy';
import { v4 } from 'uuid';
import LoadingImage from '../../Global/LoadingImage/LoadingImage';
import ActivityIcon from '../Trails/TrailCarousel/ActivityIcon';

type HeaderProps = {
	// id?: number;
	title: string;
	image: string | boolean;
	metaString: string;
	topicString?: string;
	difficultyString?: string;
	activities?: ITaxonomy[];
};

const Header: React.FC<HeaderProps> = ({
	image,
	title,
	metaString,
	topicString,
	difficultyString,
	activities,
}) => {
	return (
		<>
			<HeaderContainer>
				<LoadingImage src={checkImage(image)} />
				<Gradient />
				<TitleContainer>
					{/* TODO: Format this and add icons? */}
					{activities &&
						activities.map((activity) => {
							return (
								<ActivityIcon key={v4()} activity={activity} />
							);
						})}
					<h1>{title}</h1>
					<p>{metaString}</p>
					{!!difficultyString?.length && <p>{difficultyString}</p>}
					{!!topicString?.length && <p>{topicString}</p>}
				</TitleContainer>
			</HeaderContainer>
		</>
	);
};

export default Header;
